<template>
    <div class="content">
        <div class="section">
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>订单信息</span>
                </div>
            </div>
            <div class="info">
                <div class="data">团队订单编号：{{ content.orderSn }}</div>
                <div class="data" v-if="content.orderDetailInfoVOList.length > 0">
                    入馆日期：{{ content.orderDetailInfoVOList[0].playStartDay }}
                    {{ content.orderDetailInfoVOList[0].startTime }}-{{
                        content.orderDetailInfoVOList[0].endTime
                    }}
                </div>
                <div class="data flex-row" v-if="content.orderStatus == 4">
                    订单状态：<span style="color: #bb2916; font-weight: 600">已退款</span>
                </div>
                <div class="data flex-row" v-if="content.orderStatus == 3">
                    订单状态：<span style="color: #bb2916; font-weight: 600">已取消</span>
                    <div class="tip">订单超时，未支付</div>
                </div>
                <div class="data flex-row" v-if="content.orderStatus == 2">
                    订单状态：<span style="color: #bb2916; font-weight: 600">已使用</span>
                </div>
                <div class="data">
                    订单金额：
                    <span class="price" style="color: #bb2916">￥{{ content.totalAmount }}</span>
                    <span style="color: #bb2916; font-weight: 600" v-if="content.orderStatus == 4"
                        >（已原路返还）</span
                    >
                </div>
            </div>
            <div class="table">
                <div class="tableHeader flex-row">
                    <div class="item name">参观团队</div>
                    <div class="item">领队人员</div>
                    <div class="item idCard">证件号码</div>
                    <div class="item phone">联系电话</div>
                    <div class="item">门票名称</div>
                    <div class="item">参观总数</div>
                    <div class="item">人员名单</div>
                </div>
                <div class="tBody">
                    <div
                        class="th flex-row"
                        v-for="(item, index) in content.orderDetailInfoVOList"
                        :key="index"
                    >
                        <div class="data name ellipsis1">
                            {{ content.teamName }}
                        </div>
                        <div class="data">
                            {{ content.contact }}
                        </div>
                        <div class="data idCard">
                            {{ content.customerIdCard }}
                        </div>
                        <div class="data phone">
                            {{ content.contactNumber }}
                        </div>
                        <div class="data">
                            {{ item.productName }}
                        </div>
                        <div class="data">
                            {{ item.productQuantity }}
                        </div>
                        <div
                            class="data cursorp"
                            style="color: #bb2916; text-decoration: underline"
                            @click="showPerson(item.museumOrderUserVOS)"
                        >
                            点击查看
                        </div>
                    </div>
                </div>
            </div>
            <!--			<div class="tag flex-row">
				<img src="../../assets/img/icon-left.svg">
				<span>门票二维码</span>
				<img src="../../assets/img/icon-right.svg">
			</div>
			<div class="QR">
				<div class="status flex-row">
					<img src='../../assets/img/icon-choose.svg'>
					出票成功！
				</div>
				动态二维码门票将以短信形式发送至您的手机，或直接进入购票小程序-订单详情页查看二维码门票，或直接刷身份证入馆参观。
			</div>-->
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>支付方式</span>
                </div>
            </div>
            <div class="paymode flex-row">
                <div class="item flex-row">
                    <img
                        :src="
                            content.paymentMethod == 4
                                ? require('../../assets/img/icon-rmb.png')
                                : require('../../assets/img/icon-juhe.png')
                        "
                        alt=""
                    />
                    {{ content.paymentMethod == 4 ? "数字人民币" : "聚合支付" }}
                </div>
            </div>
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>温馨提示</span>
                </div>
            </div>
            <div class="detail">
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    团队需至少提前三天在四川大学博物馆官网或微信公众号预约购票，到团当日无法预约当天票。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    参观日请联系人提前组织好团队，按照二维码下方的进场时间从团队入口有序扫码进场，超过预约时间30分钟，二维码失效，无法入场。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    开馆时间:09:00，停止入馆时间:16:30，闭馆时间:17:00。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    咨询电话028-85412543，028-85400772。
                </div>
            </div>
            <img class="line" src="../../assets/img/icon-line.svg" />
            <div class="btnbox flex-row">
                <div class="prevbtn cursorp" @click="toPage">返回</div>
            </div>
        </div>
        <!-- 人员名单弹窗 -->
        <PersonList
            :isShowPerson="isShowPerson"
            :tableData="list"
            @changeDialog="getData"
        ></PersonList>
    </div>
</template>

<script>
import { getOrderDetail, merchantNo } from "../../utils/http.js";
import PersonList from "@/components/Dialog/PersonList.vue"; //人员名单列表
export default {
    name: "TeamUsed",
    components: {
        PersonList,
    },
    data() {
        return {
            list: [],
            radio: "",
            isShowPerson: false,
            content: {
                orderDetailInfoVOList: [],
            },
        };
    },
    mounted() {
        let orderNo = this.$route.query.orderNo;
        this.getOrderDetail({
            orderSn: orderNo,
        });
    },
    methods: {
        // 获取订单详情
        getOrderDetail(param) {
            getOrderDetail(param).then(res => {
                this.content = res.data;
            });
        },
        //点击返回
        toPage() {
            this.$router.back();
        },
        // 点击查看人员名单
        showPerson(list) {
            this.isShowPerson = true;
            this.list = list;
        },
        // 获取子组件传递的值
        getData(val) {
            this.isShowPerson = val;
        },
    },
};
</script>

<style scoped>
.content {
    width: 1200px;
    margin: auto;
    background: #fff;
    background-size: 100%;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    padding: 24px;
    box-sizing: border-box;
}

.section {
    width: 100%;
}

.section .info {
    width: 1007px;
    margin-left: 60px;
    margin-bottom: 8px;
    position: relative;
}

.section .info .data {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;
    margin-bottom: 20px;
}

.info .tip {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #bb2916;
    height: 24px;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #bb2916;
    line-height: 24px;
    margin-left: 10px;
    padding: 0 6px;
    box-sizing: border-box;
}

.info .price {
    font-size: 20px;
    font-weight: 600;
}

.section .table {
    width: 1007px;
    padding: 0 60px;
    box-sizing: border-box;
    margin-bottom: 24px;
}

.table .tableHeader {
    width: 1007px;
    height: 64px;
    border-radius: 6px 6px 0px 0px;
    background-image: url("../../assets/img/tableBG.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    justify-content: space-between;
}

.table .tableHeader .item {
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    width: 127px;
    text-align: center;
}

.table .name,
.idCard,
.phone {
    width: 187px !important;
}

.table .tBody {
    width: 1007px;
    border: 1px solid #f1f1f1;
}

.table .tBody .th {
    width: 100%;
    height: 63px;
    background: #ffffff;
    justify-content: space-between;
    border-bottom: 1px solid #f1f1f1;
}

.table .tBody .th:last-child {
    border: none !important;
}

.tBody .data span {
    display: block;
    width: 60px;
    height: 23px;
    background: #bb2916;
    border-radius: 6px;
    font-size: 12px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-left: 7px;
    line-height: 23px;
}

.tBody .th .data {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    width: 127px;
    text-align: center;
    padding: 0 6px;
    box-sizing: border-box;
    justify-content: center;
}

.section .QR {
    width: 1007px;
    height: 114px;
    padding: 0 24px;
    box-sizing: border-box;
    background: #ebf8f1;
    border: 1px solid #bb2916;
    margin-left: 60px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    margin-bottom: 24px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.section .QR .status {
    font-size: 18px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    margin-bottom: 10px;
}

.QR .status img {
    width: 34px;
    height: 34px;
    margin-right: 8px;
}

.section .paymode {
    padding: 0 60px;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 24px;
}

.section .paymode .item {
    margin-right: 16px;
    color: #333;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
}

.section .paymode .item img {
    width: 48px;
    height: 48px;
    margin-right: 14px;
}

.section .detail {
    margin: 24px 0;
    margin-left: 60px;
}

.detail .item {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    margin-bottom: 20px;
}

.detail .item img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
}

.line {
    width: 1038px;
    height: 6px;
    margin: 24px 0;
    margin-left: 60px;
}

.btnbox {
    justify-content: center;
}

.btnbox div {
    width: 324px;
    height: 60px;
    font-size: 22px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 60px;
    border-radius: 30px;
}

.btnbox .backbtn {
    color: #bb2916;
    background: #ffffff;
    border: 1px solid #bb2916;
    margin-right: 32px;
}

.btnbox .prevbtn {
    color: #ffffff;
    background: #bb2916;
}
</style>
